import TransferPresentationView from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewUpload/TransferCard/Helpers/TransferPresentationView';
import type { TransferStatus } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewUpload/TransferCard/Hooks/transferStatus/transferStatus';

const FOOTNOTE_IN_FLIGHT =
	"L'audio part chiffré, par morceaux. Une coupure ne fait pas recommencer le transfert à zéro.";

/**
 * Indexed by the status of the queue item on THIS device: a fact the server cannot see. Built once at
 * module scope, so every render of a status reads the same frozen instance.
 */
const TRANSFER_STATUS_PRESENTATIONS: Readonly<Record<TransferStatus, TransferPresentationView>> =
	Object.freeze({
		preparing: new TransferPresentationView({
			label: 'Transfert en préparation',
			detail: "Le transfert de l'enregistrement n'a pas encore commencé : il démarrera automatiquement.",
			footnote: FOOTNOTE_IN_FLIGHT,
		}),
		waiting: new TransferPresentationView({
			label: 'En attente de transfert',
			detail: "L'appareil est en ligne et attend sa prochaine tentative de transfert.",
			footnote: FOOTNOTE_IN_FLIGHT,
		}),
		offline: new TransferPresentationView({
			label: 'Hors connexion',
			detail: "L'appareil est hors réseau : le transfert reprendra à la reconnexion.",
			footnote: FOOTNOTE_IN_FLIGHT,
		}),
		transferring: new TransferPresentationView({
			label: 'Transfert en cours',
			detail: "L'enregistrement est en cours de transfert vers le serveur.",
			footnote: FOOTNOTE_IN_FLIGHT,
		}),
		verifying: new TransferPresentationView({
			label: 'Vérification en cours',
			detail: "Le serveur contrôle l'intégrité de l'enregistrement reçu.",
			footnote: FOOTNOTE_IN_FLIGHT,
		}),
		confirmed: new TransferPresentationView({
			label: 'Transfert confirmé',
			detail: "Le transfert est terminé : la réception et l'intégrité ont été confirmées par le serveur.",
			footnote: "L'empreinte calculée sur l'appareil correspond à celle reçue par le serveur.",
		}),
		failed: new TransferPresentationView({
			label: 'Échec du transfert',
			detail: "Le transfert de l'enregistrement a échoué et ne sera pas relancé automatiquement.",
			footnote: "Relancez le transfert depuis cet écran : l'enregistrement reste sur cet appareil.",
		}),
		expired: new TransferPresentationView({
			label: 'Enregistrement effacé',
			detail: "La durée de conservation sur cet appareil est dépassée : l'enregistrement a été effacé avant d'avoir été transféré.",
			footnote: 'Un enregistrement effacé après expiration ne peut plus être transféré.',
		}),
	});

export default TRANSFER_STATUS_PRESENTATIONS;
